<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl group">
      <inertia-link class="flex text-indigo-400 group-hover:text-indigo-600" :href="route('organizations')">
        <icon name="office" class="w-6 h-9 mr-3 fill-indigo-400 group-hover:fill-indigo-600" /> Organizações /
      </inertia-link>
      <span class="flex ml-1 font-medium">
        {{ form.name }}
        <img v-if="organization.photo" class="block w-8 h-8 rounded-full ml-4" :src="organization.photo" />
      </span>
    </h1>
    <trashed-message v-if="organization.deleted_at" class="mb-6" @restore="restore">
      Esta organização foi excluída.
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full lg:w-1/2" label="Nome" />
          <text-input v-model="form.email" :error="form.errors.email" class="pr-6 pb-8 w-full lg:w-1/2" label="Email" />
          <text-input v-model="form.cpf_cnpj" :error="form.errors.cpf_cnpj" class="pr-6 pb-8 w-full lg:w-1/2" label="CPF/CNPJ" />
          <text-input v-model="form.phone" :error="form.errors.phone" class="pr-6 pb-8 w-full lg:w-1/2" label="Fone" />
          <text-input v-model="form.address" :error="form.errors.address" class="pr-6 pb-8 w-full lg:w-1/2" label="Endereço" />
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label">Estado:</label>
            <select id="state_id" v-model="form.state_id" class="form-select" @change="getCities()">
              <option :value="null" />
              <option v-for="state in states" :key="state.id" :value="state.id" :selected="form.state_id === state.id">{{ state.name }}</option>
            </select>
          </div>
          <div class="pr-6 pb-8 w-full lg:w-1/2">
            <label class="form-label">Cidade:</label>
            <select id="city_id" v-model="form.city_id" class="form-select">
              <option :value="null" />
              <option v-for="city in cities" :key="city.id" :value="city.id" :selected="form.city_id === city.id">{{ city.name }}</option>
            </select>
          </div>
          <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="pr-6 pb-8 w-full lg:w-1/2" label="CEP" />
          <file-input v-model="form.photo" :error="form.errors.photo" class="pr-6 pb-8 w-full lg:w-1/2" type="file" accept="image/*" label="Imagem" />
          <select-input v-model="form.active" :error="form.errors.active" class="pr-6 pb-8 w-full lg:w-1/2" label="Ativo">
            <option :value="null" />
            <option :value="true">Sim</option>
            <option :value="false">Não</option>
          </select-input>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!organization.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Deletar Organização</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Atualizar Organização</loading-button>
        </div>
      </form>
    </div>
    <h2 class="mt-12 font-bold text-2xl">Usuários</h2>
    <div class="mt-6 bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nome</th>
          <th class="px-6 pt-6 pb-4">Email</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Fone</th>
        </tr>
        <tr v-for="user in organization.users" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-indigo-500" :href="route('users.edit', user.id)">
              {{ user.name }}
              <icon v-if="user.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('users.edit', user.id)" tabindex="-1">
              {{ user.email }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('users.edit', user.id)" tabindex="-1">
              {{ user.phone }}
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('users.edit', user.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="organization.users.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Nenhum registro</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import FileInput from '@/Shared/FileInput'
import axios from 'axios'

export default {
  metaInfo() {
    return { title: this.form.name }
  },
  components: {
    Icon,
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    organization: Object,
  },
  remember: 'form',
  data() {
    return {
      states: null,
      cities: null,
      form: this.$inertia.form({
        _method: 'put',
        name: this.organization.name,
        email: this.organization.email,
        cpf_cnpj: this.organization.cpf_cnpj,
        phone: this.organization.phone,
        address: this.organization.address,
        state_id: this.organization.state_id,
        city_id: this.organization.city_id,
        postal_code: this.organization.postal_code,
        active: this.organization.active,
        photo: null,
        state: null,
      }),
    }
  },
  mounted() {
    this.getStates()
    this.getCities()
  },
  methods: {
    update() {
      this.form.post(this.route('organizations.update', this.organization.id).url())
    },
    destroy() {
      if (confirm('Tem certeza de que deseja excluir esta organização?')) {
        this.$inertia.delete(this.route('organizations.destroy', this.organization.id))
      }
    },
    restore() {
      if (confirm('Tem certeza de que deseja restaurar esta organização?')) {
        this.$inertia.put(this.route('organizations.restore', this.organization.id))
      }
    },
    getStates() {
      axios
        .get(this.route('states'))
        .then(response => (this.states = response.data))
    },
    getCities() {
      axios
        .get(this.route('cities'), {
          params: {
            stateId:this.form.state_id,
          },
        })
        .then(response => (this.cities = response.data))
    },
  },
}
</script>
